module.exports = __webpack_public_path__ + "static/cutout-1744dab218c9422c51c25595275cb9b1.png";